var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMailicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.574,
    height: 28.904,
    viewBox: "0 0 43.574 28.904",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "email-forward",
    d: "M43.574,20.663,35.418,28.9V24.8c-5.156-1.064-9.22.11-12.326,4.032.535-8.067,6.05-11.961,12.326-12.22v-4.2l8.156,8.237ZM2.369,0H35.56a2.319,2.319,0,0,1,.9.181,2.383,2.383,0,0,1,.773.528,2.358,2.358,0,0,1,.709,1.674V9.362a.22.22,0,0,1-.22.22.234.234,0,0,1-.17-.078,3.3,3.3,0,0,0-.709-.571,3.465,3.465,0,0,0-.837-.355.223.223,0,0,1-.16-.209V3.5l-10.7,9.11L27.1,14.649a.223.223,0,0,1,0,.309l-.057.035c-.241.131-.482.266-.709.408s-.468.291-.709.447a.216.216,0,0,1-.291-.043l-1.773-1.847-3.62,3.085a1.035,1.035,0,0,1-1.333,0L14.794,13.95,3.316,25.46H18.769a.216.216,0,0,1,.22.216v.067c-.06.262-.117.525-.167.787h0c-.05.259-.1.535-.138.823a.22.22,0,0,1-.216.184H2.369a2.337,2.337,0,0,1-.9-.181,2.422,2.422,0,0,1-.755-.507,2.383,2.383,0,0,1-.528-.769h0a2.33,2.33,0,0,1-.181-.9V2.369a2.351,2.351,0,0,1,.181-.9A2.422,2.422,0,0,1,.709.709,2.461,2.461,0,0,1,1.465.181,2.337,2.337,0,0,1,2.369,0Zm-.28,23.758L13.173,12.627,2.089,3.589ZM3.546,2.089l15.705,12.8,15.035-12.8Z",
    fill: "#16b1ef",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailicon);
export default __webpack_public_path__ + "static/media/mailicon.52671e3a249c6ddc98e71be798cbdab4.svg";
export { ForwardRef as ReactComponent };